// frontend/src/components/AuthShell.js
//
// The dark, centred backdrop behind every sign-in style page. Login, Register,
// the password-reset pair and the e-mail confirmation each carried their own
// copy of the same container; they now share this one, which is also where the
// 3D strand field lives so the auth screens belong to the same site as the
// landing page rather than looking like a separate admin tool.
import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import HairFlow3D from './HairFlow3D';
import theme from '../theme';

export default function AuthShell({ children, maxWidth = 440 }) {
  const reduced = useReducedMotion();

  return (
    <div style={{
      minHeight: '100vh', background: `linear-gradient(135deg, ${theme.espresso}, ${theme.espressoDeep})`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24, fontFamily: theme.font.body,
      position: 'relative', overflow: 'hidden',
    }}>
      {/* No vignette behind the card: the card is opaque white and already
          masks the middle of the field, so darkening it twice only dulls the
          strands that show around the edges. */}
      <HairFlow3D
        widen={1.5}
        wash={`radial-gradient(ellipse 80% 70% at 50% 20%, ${theme.alpha.gold(0.14)} 0%, transparent 72%)`}
        vignette={`radial-gradient(ellipse 60% 55% at 50% 50%, ${theme.alpha.inkDeep(0.35)} 0%, transparent 78%)`}
      >
        <div style={{
          position: 'absolute', inset: 0, pointerEvents: 'none',
          background: `radial-gradient(circle at 50% 30%, ${theme.alpha.gold(0.10)} 0%, transparent 65%)`,
        }} />
      </HairFlow3D>

      <motion.div
        initial={reduced ? false : { opacity: 0, y: 22, scale: 0.985 }}
        animate={reduced ? false : { opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
        style={{
          position: 'relative',
          background: theme.white, borderRadius: 4, padding: '48px 40px',
          width: '100%', maxWidth, boxShadow: `0 24px 80px ${theme.alpha.black(0.45)}`,
        }}>
        {children}
      </motion.div>
    </div>
  );
}
